import {
  PASSWORD_ENFORCEMENT_CHANGE_SUBMIT,
  PASSWORD_ENFORCEMENT_REGISTER_SUBMIT,
  PASSWORD_ENFORCEMENT_RESET_SUBMIT,
} from 'shared/experiments/browser/passwordEnforcement/consts'
import {
  EXPERIMENT_VARIATION,
  PASSWORD_ENFORCEMENT_AB_TEST,
  PASSWORD_ENFORCEMENT_CHANGE_PASSWORD,
  PASSWORD_ENFORCEMENT_RESET_PASSWORD,
} from 'shared/experiments/consts'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import { isPasswordGdprCompliant } from 'views/assets/scripts/gdprPasswordValidator'

const passwordEnforcementTrackingRegister = () => {
  const { isEnabled, variant } = getExperimentOnClient(
    PASSWORD_ENFORCEMENT_AB_TEST
  )

  if (!isEnabled) {
    return
  }

  const registerForm = document.querySelector('#register-form') as HTMLElement
  registerForm?.addEventListener('submit', e => {
    const form = e.target as HTMLFormElement
    const password = form.querySelector(
      'input[id="registerForm-password"]'
    ) as HTMLInputElement

    if (form.checkValidity()) {
      if (variant === EXPERIMENT_VARIATION.DEFAULT) {
        trackEvent(PASSWORD_ENFORCEMENT_REGISTER_SUBMIT)
      } else if (isPasswordGdprCompliant(password.value)) {
        trackEvent(PASSWORD_ENFORCEMENT_REGISTER_SUBMIT)
      }
    }
  })
}

const passwordEnforcementTrackingReset = () => {
  const { isEnabled, variant } = getExperimentOnClient(
    PASSWORD_ENFORCEMENT_RESET_PASSWORD
  )

  if (!isEnabled) {
    return
  }

  const resetPasswordForm = document.querySelector(
    '#reset-password-form'
  ) as HTMLElement
  resetPasswordForm?.addEventListener('submit', e => {
    const form = e.target as HTMLFormElement
    const password = form.querySelector(
      'input[name="resetPassword.password"]'
    ) as HTMLInputElement

    if (form.checkValidity()) {
      if (variant === EXPERIMENT_VARIATION.DEFAULT) {
        trackEvent(PASSWORD_ENFORCEMENT_RESET_SUBMIT)
      } else if (isPasswordGdprCompliant(password.value)) {
        trackEvent(PASSWORD_ENFORCEMENT_RESET_SUBMIT)
      }
    }
  })
}

const passwordEnforcementTrackingChange = () => {
  const { isEnabled, variant } = getExperimentOnClient(
    PASSWORD_ENFORCEMENT_CHANGE_PASSWORD
  )

  if (!isEnabled) {
    return
  }

  const changePasswordForm = document.querySelector(
    '#change-password-form'
  ) as HTMLElement
  changePasswordForm?.addEventListener('submit', e => {
    const form = e.target as HTMLFormElement
    const password = form.querySelector(
      'input[name="changePassword.password"]'
    ) as HTMLInputElement

    if (form.checkValidity()) {
      if (variant === EXPERIMENT_VARIATION.DEFAULT) {
        trackEvent(PASSWORD_ENFORCEMENT_CHANGE_SUBMIT)
      } else if (isPasswordGdprCompliant(password.value)) {
        trackEvent(PASSWORD_ENFORCEMENT_CHANGE_SUBMIT)
      }
    }
  })
}
export {
  passwordEnforcementTrackingRegister,
  passwordEnforcementTrackingChange,
  passwordEnforcementTrackingReset,
}
